<template>
  <div>
    <card title="Fórmulas" icon="fas fa-flask">
      <div class="row">
        <div class="col-4 offset-8">
          <search-options
            :placeholder="'Buscar por Sku o Descripción...'"
            :links="links"
            @index="index"
            @reset="reset"
          ></search-options>
        </div>
      </div>
     
      <div class="table-responsive">
        <manage-table
          :hover="true"
          :headers="[
            'SKU',
            'Descripción',
            'Fórmula',
            'Componente',
            'Cosecha',
            'Zona Venta',
            'Vigente',
            'Petición de Borrado'
          ]"
        >
          <tr v-for="f in formulas" v-bind:key="f.id">
            <td>{{ f.c_sku }}</td>
            <td>{{ f.d_sku }}</td>
            <td>{{ f.formula }}</td>
            <td>{{ f.component }}</td>
            <td>{{ f.harvest }}</td>
            <td>{{ f.sale_zone }}</td>
            <td>{{ f.status }}</td>
            <td>{{ f.deletetionRequest }}</td>
          </tr>
        </manage-table>
      </div>
      <paginator class="mt-4" :links="links"></paginator>
    </card>
  </div>
</template>

<script>
import { Get, Delete, Post, Put } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
import { getUrlQuery } from "../../helper/queryHelper";
export default {
  components: {
    Card,
  },
  data() {
    return {
      formulas: [],
      Post,
      Delete,
      apiUrl: this.$store.getters.apiUrl,
      Get,
      Put,
      links: {},
      getUrlQuery,
    };
  },
  watch: {
    urlQuery: function () {
      this.index();
    },
  },
  created() {
    this.index();
  },
  methods: {
    index() {
      this.$store.commit("setLoading", true);
      this.Get(this.apiUrl + "v1/formulas?" + this.urlQuery, (res) => {
        this.formulas = res.data.data;
        this.links = res.data.links;
        this.$store.commit("setLoading", false);
      });
    },
    update() {
      this.$swal({
        title: "¿Desea Actualizar las formulas desde PRO SAP?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.value) {
          this.$store.commit("setLoading", true);
          this.Post(this.apiUrl + "v1/SyncWsFormulas/", () => {
            this.$store.commit("setLoading", false);
            this.$swal.fire(
              "Sincronización Finalizada",
              "Las Fórmulas han sido actualizada correctamente desde PRO SAP."
            );
          });
          // this.$router.go(this.$router.currentRoute);
        }
      });
    },
    reset() {
      this.links = {};
      this.index();
    },
  },
  computed: {
    urlQuery() {
      return this.getUrlQuery();
    },
  },
};
</script>
